import { isAxiosError } from "axios";

import { apiErrorMessage } from "./apiErrorMessage.ts";

/** A change the server would not make in the state it found the task in. */
export function isConflict(error: unknown): boolean {
  return isAxiosError(error) && error.response?.status === 409;
}

/**
 * What a failed change to the list says.
 *
 * `stale` belongs to a write that carried the state its control was showing.
 * Today that is the status change alone: it sends `fromStatus`, the status the
 * row drew. A conflict there means the task moved since, which is worth saying
 * plainly — the user can act on it, and the refetch has already put the list
 * right. A write that sends no such precondition cannot produce that conflict,
 * so it must not claim it.
 *
 * Everywhere else the server's own words stand, because 409 is not only
 * staleness. It is also how the server refuses a change the control should not
 * have offered — answering a suggested task outside Triage, taking back a task
 * okthx does not hold, "Same as…" naming no other task — and it writes those in
 * words the user can act on. Telling them instead that the page is out of date
 * would be untrue, and would send them to wait for a refetch that fixes
 * nothing.
 */
export function taskErrorMessage(
  error: unknown,
  fallback: string,
  { stale = false }: { stale?: boolean } = {},
): string {
  if (stale && isConflict(error))
    return "This changed since the page loaded. The list is up to date now.";
  return apiErrorMessage(error) ?? fallback;
}
